/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/29/2026
 */

export const SubscriptionBillingTypeEnum = Object.freeze({
	TIME_BASED: "TIME_BASED",
	USAGE_BASED: "USAGE_BASED",
})

